<template>
  <b-card-code
      title="Szerkesztés"
  >
    <!-- form -->
    <validation-observer ref="simpleRules">
      <b-form>
        <b-row>
          <b-col md="12">
            <b-form-group
                label="Név"
            >
              <validation-provider
                  #default="{ errors }"
                  name="név"
                  rules="required"
                  vid="name"
              >
                <b-form-input
                    v-model="formData.name"
                    :state="errors.length > 0 ? false:null"
                    placeholder="név"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
                label="Jogosultságok"
            >
              <validation-provider
                  #default="{ errors }"
                  name="jogosultságok"
                  rules="required"
                  vid="permissions"
              >
                <v-select
                    v-model="formData.permissions"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :options="permissionOptions"
                    multiple
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- submit button -->
          <b-col class="mt-1">
            <b-button
                variant="primary"
                type="submit"
                class="float-right"
                @click.prevent="submitForm"
            >
              Mentés
            </b-button>
            <cancel-and-g-o-t-o-previous-page class="mr-2"/>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BButton, BFormCheckbox,
} from 'bootstrap-vue'
import {
  required,
} from '@validations'
import vSelect from 'vue-select'
import cancelAndGOTOPreviousPage from '@/views/pages/_components/_helper/cancelAndGOTOPreviousPage'

export default {
  components: {
    BCardCode,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormCheckbox,
    vSelect,
    cancelAndGOTOPreviousPage,
  },
  data() {
    return {
      role: 'role',
      formData: {
        id: null,
        name: '',
        permissions: '',
      },
      permissionOptions: [],
      required,
    }
  },
  created() {
    this.$store.dispatch('fetchRole', this.$route.params.id).then(response => {
      this.formData.id = this.$route.params.id
      this.formData.name = response.data.entity.name
      this.formData.guard_name = response.data.entity.guard_name

      this.$store.dispatch('fetchPermissionsForSelect').then(plResponse => {
        this.permissionOptions = plResponse

        if (response.data.entity.permissions && response.data.entity.permissions.length) {
          const items = []

          Object.keys(response.data.entity.permissions).forEach(key => {
            Object.keys(this.permissionOptions).forEach(optionKey => {
              if (response.data.entity.permissions[key].id === this.permissionOptions[optionKey].value) {
                items.push(this.permissionOptions[optionKey])
              }
            })
          })

          if (items.length) {
            this.formData.permissions = items
          } else if (this.permissionOptions.length === 1) {
            // eslint-disable-next-line prefer-destructuring
            this.formData.permissions = this.permissionOptions[0]
          } else {
            this.formData.permissions = ''
          }
        }
      })
    })
  },
  methods: {
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          let fd = { ... this.formData}

          const items = []
          Object.keys(this.formData.permissions).forEach(key => {
            items.push(this.formData.permissions[key].value)
          })

          fd.permissions = items

          this.$store.dispatch('updateRole', fd).then(() => {
            this.$helpers.showSuccessToast()

            this.$acl.canListPermission(this.role)
                ? this.$router.push({ name: 'roles' })
                : this.$router.go(-1)
          }).catch(error => {
            if (error.response.status === 422) {
              this.$refs.simpleRules.setErrors(error.response.data.errors)
            } else {
              this.$helpers.showErrorToast(error.toString())
            }
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
